import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { config } from "./Components/Config";

import Login from "./Login";
import Logout from "./Logout";

import GuestLogin from "./Guest/Login";
import MarketingLayout from "./Marketing/Layout";
import MarketingDashboard from "./Marketing/Dashboard";
import MarketingReports from "./Marketing/Reports";
import MarketingClients from "./Marketing/Clients";

import Dashboard from "./Dashboard";
import Monitor from "./Monitor";
import Report from "./Report";
import Lead from "./Lead";
import LeadAdd from "./LeadAdd";
import LeadDetail from "./LeadDetail";
import LeadEdit from "./LeadEdit";
import LeadOpportunity from "./LeadOpportunity";
import LeadReport from "./LeadReport";
import Opportunity from "./Opportunity";
import OpportunityAdd from "./OpportunityAdd";
import OpportunityDetail from "./OpportunityDetail";
import OpportunityEditBant from "./OpportunityEditBant";
import OpportunityEditDetail from "./OpportunityEditDetail";
import Quotation from "./Quotation";
import QuotationAdd from "./QuotationAdd";
import QuotationDetail from "./QuotationDetail";
import QuotationEdit from "./QuotationEdit";
import QuotationView from "./QuotationView";
import QuotationBilling from "./QuotationBilling";
import QuotationApproval from "./QuotationApproval";
import QuotationApprovalResponse from "./QuotationApprovalResponse";
import QuotationPrint from "./QuotationPrint";
import QuotationAtb from "./QuotationAtb";
import QuotationAtbDetail from "./QuotationAtbDetail";
import QuotationAtbSent from "./QuotationAtbSent";
import QuotationContract from "./QuotationContract";
import SalesOrder from "./SalesOrder";
import SalesOrderDetail from "./SalesOrderDetail";
import SalesOrderAdd from "./SalesOrderAdd";
import InvoiceRequest from "./InvoiceRequest";
import InvoiceRequestDetail from "./InvoiceRequestDetail";
import InvoiceRequestPrint from "./InvoiceRequestPrint";
import InvoiceRequestList from "./InvoiceRequestList";
import User from "./User";
import UserAdd from "./UserAdd";
import UserDetail from "./UserDetail";
import UserEdit from "./UserEdit";
import Client from "./Client";
import ClientAdd from "./ClientAdd";
import ClientDetail from "./ClientDetail";
import ClientEdit from "./ClientEdit";
import Subsidiary from "./Subsidiary";
import SubsidiaryAdd from "./SubsidiaryAdd";
import SubsidiaryDetail from "./SubsidiaryDetail";
import SubsidiaryEdit from "./SubsidiaryEdit";
import Contact from "./Contact";
import ContactAdd from "./ContactAdd";
import ContactDetail from "./ContactDetail";
import ContactEdit from "./ContactEdit";
import Product from "./Product";
import ProductAdd from "./ProductAdd";
import ProductDetail from "./ProductDetail";
import ProductEdit from "./ProductEdit";
import Category from "./Category";
import CategoryAdd from "./CategoryAdd";
import CategoryDetail from "./CategoryDetail";
import CategoryEdit from "./CategoryEdit";
import Subcategory from "./Subcategory";
import SubcategoryAdd from "./SubcategoryAdd";
import SubcategoryDetail from "./SubcategoryDetail";
import SubcategoryEdit from "./SubcategoryEdit";
import Attainment from "./Attainment";
import AttainmentDetail from "./AttainmentDetail";
import Profile from "./Profile";
import ContractDetail from "./ContractDetail";
import ContractEdit from "./ContractEdit";
import ContractSchedule from "./ContractSchedule";
import Ticket from "./Ticket";
import TicketDetail from "./TicketDetail";
import Tags from "./Tags";
import Queue from "./Queue";
import NotifEmail from "./NotifEmail";
import SupportReport from "./SupportReport";


import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./style.css";
import Display from "./Public/Display";
import AiSetting from "./AiSetting";
import Event from "./Event";
import EventContact from "./EventContact";
import EventContactDetail from "./EventContactDetail";
import DetailEvent from "./DetailEvent";
import DetailParticipant from "./DetailParticipant";
import Invitation from "./Invitation";

const App = () => {
  let crmUser = localStorage.getItem("crmUser");
  const userData = localStorage.getItem("userData");

  // Validate JWT session - force re-login if token missing (old session without JWT)
  if (crmUser) {
    try {
      const user = JSON.parse(crmUser);
      // If token is missing, it's an old session - clear it
      if (!user.token) {
        localStorage.removeItem('crmUser');
        localStorage.removeItem('userData');
        crmUser = null;
      }
    } catch (e) {
      // If can't parse, clear it
      localStorage.removeItem('crmUser');
      localStorage.removeItem('userData');
      crmUser = null;
    }
  }

  return (
    <BrowserRouter>
      <GoogleOAuthProvider clientId={config.CLIENT_ID} redirectUri={config.ENDPOINT}>
        {userData ? (
          <Routes>
            <Route
              path="/"
              element={
                <MarketingLayout
                  userData={JSON.parse(userData)}
                  children={<MarketingDashboard userData={JSON.parse(userData)} />}
                  menu="dashboard"
                />
              }
            />
            <Route
              path="/dashboard"
              element={
                <MarketingLayout
                  userData={JSON.parse(userData)}
                  children={<MarketingDashboard userData={JSON.parse(userData)} />}
                  menu="dashboard"
                />
              }
            />
            <Route
              path="/reports"
              element={
                <MarketingLayout
                  userData={JSON.parse(userData)}
                  children={<MarketingReports userData={JSON.parse(userData)} />}
                  menu="reports"
                />
              }
            />
            <Route
              path="/clients"
              element={
                <MarketingLayout
                  userData={JSON.parse(userData)}
                  children={<MarketingClients userData={JSON.parse(userData)} />}
                  menu="clients"
                />
              }
            />
            <Route path="/logout" element={<Logout />} />
            <Route path="*" element={<MarketingLayout userData={JSON.parse(userData)} />} />
          </Routes>
        ) : crmUser ? (
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/monitor" element={<Monitor />} />
            <Route path="/report" element={<Report />} />
            <Route path="/lead" element={<Lead />} />
            <Route path="/lead/add" element={<LeadAdd />} />
            <Route path="/lead/detail/:id_lead" element={<LeadDetail />} />
            <Route path="/lead/edit/:id_lead" element={<LeadEdit />} />
            <Route path="/lead/opportunity/:id_lead" element={<LeadOpportunity />} />
            <Route path="/lead/report" element={<LeadReport />} />
            <Route path="/opportunity" element={<Opportunity />} />
            <Route path="/opportunity/add" element={<OpportunityAdd />} />
            <Route path="/opportunity/detail/:id_opportunity" element={<OpportunityDetail />} />
            <Route
              path="/opportunity/edit/bant/:id_opportunity"
              element={<OpportunityEditBant />}
            />
            <Route
              path="/opportunity/edit/detail/:id_opportunity"
              element={<OpportunityEditDetail />}
            />
            <Route path="/quotation" element={<Quotation />} />
            <Route path="/quotation/add" element={<QuotationAdd />} />
            <Route path="/quotation/add/:id_company" element={<QuotationAdd />} />
            <Route path="/quotation/add/:id_company/:id_subcompany/:id_opportunity" element={<QuotationAdd />} />
            <Route path="/quotation/detail/:id_quotation" element={<QuotationDetail />} />
            <Route path="/quotation/edit/:id_quotation" element={<QuotationEdit />} />
            <Route path="/quotation/view/:id_quotation" element={<QuotationView />} />
            <Route path="/quotation/billing/:id_quotation" element={<QuotationBilling />} />
            <Route path="/quotation/approval/:id_quotation" element={<QuotationApproval />} />
            <Route path="/quotation/approval-response/:id_quotation" element={<QuotationApprovalResponse />} />
            <Route path="/quotation/print/:id_quotation" element={<QuotationPrint />} />
            <Route path="/quotation/contract/:id_quotation" element={<QuotationContract />} />
            <Route path="/quotation/atb/:id_quotation/:term_number" element={<QuotationAtb />} />
            <Route
              path="/quotation/atb/detail/:id_quotation/:term_number"
              element={<QuotationAtbDetail />}
            />
            <Route
              path="/quotation/atb/sent/:id_quotation/:term_number"
              element={<QuotationAtbSent />}
            />
            <Route path="/salesorder" element={<SalesOrder />} />
            <Route path="/salesorder/detail/:id_so" element={<SalesOrderDetail />} />
            <Route path="/salesorder/add/:id_quotation" element={<SalesOrderAdd />} />
            <Route path="/invoicerequest" element={<InvoiceRequest />} />
            <Route path="/invoicerequest/detail/:id_iou" element={<InvoiceRequestDetail />} />
            <Route path="/invoicerequest/print/:id_iou" element={<InvoiceRequestPrint />} />
            <Route path="/invoicerequest/list/:type" element={<InvoiceRequestList />} />
            <Route path="/iou" element={<InvoiceRequest />} />
            <Route path="/iou/detail/:id_iou" element={<InvoiceRequestDetail />} />
            <Route path="/iou/edit/:id_iou" element={<InvoiceRequestDetail />} />
            <Route path="/user" element={<User />} />
            <Route path="/user/add" element={<UserAdd />} />
            <Route path="/user/detail/:user_keyid" element={<UserDetail />} />
            <Route path="/user/edit/:user_keyid" element={<UserEdit />} />
            <Route path="/client" element={<Client />} />
            <Route path="/client/add" element={<ClientAdd />} />
            <Route path="/client/detail/:id_company" element={<ClientDetail />} />
            <Route path="/client/edit/:id_company" element={<ClientEdit />} />
            <Route path="/client/subsidiary" element={<Subsidiary />} />
            <Route path="/client/subsidiary/add" element={<SubsidiaryAdd />} />
            <Route path="/client/subsidiary/add/:id_company" element={<SubsidiaryAdd />} />
            <Route path="/client/subsidiary/detail/:id_subcompany" element={<SubsidiaryDetail />} />
            <Route path="/client/subsidiary/edit/:id_subcompany" element={<SubsidiaryEdit />} />
            <Route path="/client/contact" element={<Contact />} />
            <Route path="/client/contact/detail/:id_contact" element={<ContactDetail />} />
            <Route path="/client/contact/add" element={<ContactAdd />} />
            <Route path="/client/contact/add/:id_company" element={<ContactAdd />} />
            <Route path="/client/contact/edit/:id_contact" element={<ContactEdit />} />
            <Route path="/client/contract/detail/:id_contract" element={<ContractDetail />} />
            <Route path="/client/contract/edit/:id_contract" element={<ContractEdit />} />
            <Route path="/client/contract/schedule/:id_schedule" element={<ContractSchedule />} />
            <Route path="/product" element={<Product />} />
            <Route path="/product/add" element={<ProductAdd />} />
            <Route path="/product/add/category/:id_product_category" element={<ProductAdd />} />
            <Route
              path="/product/add/category/:id_product_category/:id_product_subcategory"
              element={<ProductAdd />}
            />
            <Route path="/product/detail/:id_product" element={<ProductDetail />} />
            <Route path="/product/edit/:id_product" element={<ProductEdit />} />
            <Route path="/product/category" element={<Category />} />
            <Route path="/product/category/add" element={<CategoryAdd />} />
            <Route
              path="/product/category/detail/:id_product_category"
              element={<CategoryDetail />}
            />
            <Route path="/product/category/edit/:id_product_category" element={<CategoryEdit />} />
            <Route path="/product/category/subcategory" element={<Subcategory />} />
            <Route path="/product/category/subcategory/add" element={<SubcategoryAdd />} />
            <Route
              path="/product/category/subcategory/add/:id_product_category"
              element={<SubcategoryAdd />}
            />
            <Route
              path="/product/category/subcategory/detail/:id_product_subcategory"
              element={<SubcategoryDetail />}
            />
            <Route
              path="/product/category/subcategory/edit/:id_product_subcategory"
              element={<SubcategoryEdit />}
            />
            <Route path="/attainment" element={<Attainment />} />
            <Route path="/attainment/detail/:id_attainment" element={<AttainmentDetail />} />
            <Route path="/support-report" element={< SupportReport />} />
            <Route path="/ticket" element={< Ticket />} />
            <Route path="/ticket/:id" element={< TicketDetail />} />
            <Route path="/tags" element={< Tags />} />
            <Route path="/queue" element={< Queue />} />
            <Route path="/event" element={<Event />} />
            <Route path="/event/invitation/:id" element={<Invitation />} />
            <Route path="/event/detail/:id" element={<DetailEvent />} />
            <Route path="/event/detail/:id/participant/:participantId" element={<DetailParticipant />} />
            <Route path="/event/ai-setting" element={<AiSetting />} />
            <Route path="/event/contact" element={<EventContact />} />
            <Route path="/event/contact/:id" element={<EventContactDetail />} />
            <Route path="/notif-email" element={< NotifEmail />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="*" element={<Dashboard />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/guest/login" element={<GuestLogin />} />
            <Route path="/display" element={<Display />} />
            <Route path="/quotation/approval-response/:id_quotation" element={<QuotationApprovalResponse />} />
            <Route path="*" element={<Login />} />
          </Routes>
        )}
      </GoogleOAuthProvider>
    </BrowserRouter>
  );
};

export default App;
